import { lazy, Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import { ProbationRecordDetailsProvider } from '@/pages/probation/probation-details/useProbationRecordDetails.ts'

const ProbationListPage = lazy(() => import('@/pages/probation/probation-list/probation-list-page.tsx'))
const ProbationDetailsPage = lazy(() => import('@/pages/probation/probation-details/probation-details-page.tsx'))

export const probationRoutes: RouteObject = {
  path: 'probation',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}><ProbationListPage /></Suspense>,
    },
    {
      path: ':probationRecordId',
      element: <Suspense fallback={<SuspenseLoading />}>
        <ProbationRecordDetailsProvider>
          <ProbationDetailsPage />
        </ProbationRecordDetailsProvider>
      </Suspense>,
    },
  ],
}
